import { createFileRoute } from '@tanstack/react-router';

import { DictionaryBrowse } from '@/module/Author/Dictionary';

export const Route = createFileRoute('/_auth/author/_author/dictionary/_dictionary/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DictionaryBrowse />;
}
